<template>
  <v-card class="pa-5">
    <v-card-title class="text-center">参加申込フォーム</v-card-title>
    <v-card-text>以下の内容をご記入の上、お申し込みください。<p class="text-end" style="color:red;"><strong class="required">※</strong>…必須項目
      </p></v-card-text>

    <v-divider />

    <v-form ref="form" method="post" action="/seminar/202512/thanks">
      <v-row class="align-end d-none">
        <v-col cols="12">
          <v-label for="term">
            <v-input v-model="imrobot" type="checkbox" name="term" required />
            わたしはロボットです
            ※もしあなたがロボットではない場合は✓を入れてはいけません
          </v-label>
        </v-col>
      </v-row>

      <v-row class="name align-end">
        <v-col cols="12">
          <v-label text="現在の状況" />
          <v-select v-model="model.currentStatus" name="current_status" item-title="label" item-value="value"
            density="compact" :items="Object.values(currentStatusItems)" :rules="[
              isRequired('現在の状況', 'select'),
            ]" required />
        </v-col>
      </v-row>

      <v-row class="name align-end">
        <v-col cols="12">
          <v-label text="現在お勤めの会社名・大学名" />
          <v-text-field name="company_name" v-model="model.companyName" :rules="[
            isRequired('現在お勤めの会社名・大学名', 'text'),
          ]" placeholder="株式会社C&Rリーガル･エージェンシー社" hint="どこにも属さない場合は「なし」とお書きください。" :persistent-hint="true"
            variant="outlined" density="compact" required />
        </v-col>
      </v-row>

      <v-row class="align-end">
        <v-col cols="6">
          <v-label text="氏名" />
          <v-text-field name="lastname" v-model="model.lastname" :rules="[
            isRequired('氏名（姓）', 'text'),
          ]" label="（姓）" placeholder="田中" variant="outlined" density="compact" required />
        </v-col>

        <v-col cols="6">
          <v-text-field name="firstname" v-model="model.firstname" :rules="[
            isRequired('氏名（名）', 'text'),
          ]" label="（名）" placeholder="太郎" variant="outlined" density="compact" required />
        </v-col>
      </v-row>
      <v-row class="align-end">
        <v-col cols="12" md="12">
          <v-label text="メールアドレス" />
          <v-text-field name="email" v-model="model.email" :rules="[
            isRequired('メールアドレス', 'text'),
            isSutisfiedWithFormat('メールアドレス', emailFormatRegex),
          ]" placeholder="info@example.com" variant="outlined" density="compact" required />
        </v-col>
        <v-col cols="12" md="12">
          <v-label text="メールアドレス（確認用）" />
          <v-text-field v-model="emailVerify" :rules="[
            isRequired('メールアドレス（確認用）', 'text'),
            isSutisfiedWithFormat('メールアドレス（確認用）', emailFormatRegex),
            isEqualledWithItem('メールアドレス（確認用）', model.email, 'メールアドレス'),
          ]" placeholder="info@example.com" variant="outlined" density="compact" required />
        </v-col>
      </v-row>
      <v-row class="align-end">
        <v-col cols="12">
          <v-label text="ご年齢" />
          <v-select class="no_error_message" v-model="model.era" density="compact" item-title="label" item-value="value"
            required :items="Object.values(eraItems)" :rules="[
              isRequired('ご年齢', 'select'),
            ]" />
        </v-col>
      </v-row>
      <span>アンケート</span>
      <p style="font-size:0.75rem;">当日お話しする内容の参考のため、ご協力をお願いします。</p>
      <v-row class="align-end">
        <v-col cols="12">
          <v-label text="最終学歴" />
          <v-select name="last_educational_background" class="no_error_message" density="compact" :items="Object.values(lastEducationalBackgroundItems)" item-title="label"
            item-value="value" v-model="model.lastEducationalBackground" :rules="[
              isRequired('最終学歴', 'select'),
            ]" required />
        </v-col>
      </v-row>
      <v-row class="align-end">
        <v-col cols="12">
          <v-label text="受験歴・資格" />
          <v-checkbox name="exam_history_and_qualifications" class="no_error_message" density="compact"
            :label="item.label" :value="item.value" v-for="item in examHistoryAndQualifications" item-title="label"
            item-value="value" v-model="model.examHistoryAndQualifications" />
        </v-col>
      </v-row>
      <v-row class="align-end">
        <v-col cols="12">
          <v-label text="講師にお聞きしたいことをご記入ください" />
          <v-textarea name="q_and_a" v-model="model.q_and_a" variant="outlined" density="compact" />
        </v-col>
      </v-row>
      <v-row class="align-end">
        <v-col cols="12">
          <v-checkbox class="privacy-policy" v-model="ppagreement" :rules="[
            isRequired('個人情報への同意', 'checkbox', '<<label>>が必要です。')
          ]" density="compact" required>
            <template v-slot:label>
              <div>
                <client-only>
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <a href="https://legal-agent.jp/privacypolicy/" target="_blank" v-bind="props" @click.stop>
                        個人情報の取り扱い
                      </a>
                    </template>
                    Opens in new window
                  </v-tooltip>
                </client-only>
                に同意します。
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-form>
    <v-divider />
    <div class="mt-6 text-center">
      <v-btn variant="flat" block color="primary" size="large" @click="nextHandler">申し込む</v-btn>
    </div>
    <v-overlay v-if="isMounted" persistent class="align-center justify-center" :no-click-animation="true" v-model="isExpiredApply" contained>
      <p style="opacity:1;font-weight:700;">このセミナーの参加受付は終了しました</p>
    </v-overlay>
    <v-overlay v-if="isMounted" persistent class="align-center justify-center" :no-click-animation="true" v-model="overlay" contained>
      <v-progress-circular color="primary" indeterminate />
      <p>処理中です</p>
    </v-overlay>
  </v-card>
</template>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden;
}

div[class^=v-col]:has(:required)>.v-label {
  &::before {
    content: '※';
    color: #ff0000;
    font-weight: 700;
  }
}

.v-card {
  & .v-overlay {
    & .v-overlay__content {
      text-align: center;
    }
  }

  & .v-sheet {
    & .v-stepper-header {
      & .v-stepper-item {
        padding: 0.75rem;
      }
    }

    & .v-window {
      margin: 0.5rem;

      & .v-form {
        & .v-row {
          margin: 0;

          & [class^="v-col"] {
            padding: 0.25rem;

            & .v-input {
              line-height: 1;

              &.v-input--plain-underlined .v-field .v-field__field {
                & label {
                  display: block;
                }
              }

              &.v-checkbox.no_error_message,
              &.v-checkbox.privacy-policy:not(:has(.v-selection-control--error)),
              &.v-select.no_error_message {
                & .v-input__details {
                  display: none;
                }
              }

              & .v-input__details {
                padding: 0 !important;
                font-size: 0.3rem;
              }

              &[name=term] {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<script setup lang="ts">
import { ref } from 'vue';
import { isRequired, isSutisfiedWithFormat, isEqualledWithItem, emailFormatRegex } from '@/libs/validation';
import { currentStatusItems, lastEducationalBackgroundItems, examHistoryAndQualifications, eraItems } from '@/assets/hubspot/seminar_form';
interface Props {
  isExpiredApply: boolean;
  seminarVar: Object;
}

const props = defineProps<Props>();
const isExpiredApply = ref(props.isExpiredApply);

const eventStartDateTimeString: string = props.seminarVar.schedule.start;
const eventEndDateTimeString: string = props.seminarVar.schedule.end;

const eventStartDateTime: Date = new Date(eventStartDateTimeString);
const eventEndDateTime: Date = new Date(eventEndDateTimeString);

const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const runtimeConfig = useRuntimeConfig();
useHead({
  script: [
    {
      key: 'load-grecapcha-script',
      src: `https://www.google.com/recaptcha/api.js?render=${runtimeConfig.public.googleRecapchaSiteKey!}`,
      async: true,
      defer: true,
    },
  ],
});
interface Model {
  currentStatus?: string;
  companyName?: string;
  lastname?: string;
  firstname?: string;
  email?: string;
  tel?: string;
  lastEducationalBackground?: string | null;
  examHistoryAndQualifications?: string[] | null;
  era?: number | null;
  q_and_a?: string | null;
}

const model: Ref<Model> = ref({
  examHistoryAndQualifications: [],
});

const form = ref();

// スパムトラップ
// URL : https://zenn.dev/coedo/articles/spam-free-mail-form
const imrobot = ref(false);
const ppagreement = ref(false);
const emailVerify = ref('');
const overlay = ref(false);


const nextHandler = (async () => {
  if (import.meta.client) {
    if (!imrobot.value) {
      const { valid } = await form.value.validate();
      try {
        if (valid) {
          overlay.value = true;
          // grecaptcha が読み込まれているか確認
          //@ts-ignore grecaptchaが読み込まれているかの確認
          if (!window.grecaptcha) {
            throw new Error('reCAPTCHA is not loaded')
          }

          // トークンを取得（アクション名は自由につけてOK）
          //@ts-ignore grecaptchaが読み込まれているかの確認
          const recaptchaToken = await window.grecaptcha.execute(runtimeConfig.public.googleRecapchaSiteKey, {
            action: 'submit'
          });

          let requestBody = {
            ...model.value,
            recaptchaToken: recaptchaToken,
            pageUrl: useRequestURL().toString(),
            pageTitle: document.title,
            //TODO: 次回以降はここを元に戻す
            // seminarDatetime: `${getDateStringJP(eventStartDateTime)}～${getDateStringJP(eventEndDateTime, true)}`,
            seminarDatetime: `2025/12/10（水） 12:00～13:00、19:00～20:00\n※いずれの日程でご参加いただけます。`,
            seminarDetailUrl: `${runtimeConfig.public.appUrlOrigin}/seminar/202512`,
            joinedSeminars: props.seminarVar.seminar_id,
          };

          if(props.seminarVar.webinarUrl != ""){
            requestBody.mailTemplate = "attorneys_academy_seminar_thanks_with_url";
            requestBody.webinarUrl = props.seminarVar.webinarUrl;
          }else{
            requestBody.mailTemplate = "attorneys_academy_seminar_thanks";
          }

          const { data, status, error } = await useFetch(`/api/form/${props.seminarVar.form_id}`, {
            method: 'POST',
            body: requestBody,
          });
          if (status.value !== "success") {
            overlay.value = false;
          } else {
            form.value.submit();
          }
        }
      } catch (error) {
        throw error;
      }
    }
  }
});
</script>
